import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Badge,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import { changeOrderStatus } from "../../../../../services/OrderStatus/OrderStatusApi";
import { ThemeContext } from "../../../../../context/ThemeContextProvider";
import { fetchDeliveryOrders } from "../../../../../services/pos/Tables";
import CreateOrderForm from "../../MakeOrderResponsive/TabletMakeOrder/deliveryTablet/OrderDetails/Openorder/CreateOrderForm";
import DeliveryModalContent from "../../MakeOrderResponsive/TabletMakeOrder/deliveryTablet/DeliveryModalContent";
import { usePermissions } from "../../../../../context/PermissionsAndFeatures/UserPermissionsContext";
import { useTheme, useMediaQuery } from "@mui/material";
import OrderItemsDialog from "./OrderItemsDialog";

const TabletDeliverySection = () => {
  const { mode } = useContext(ThemeContext);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg")); // عام للتابلت
  const isIpad = useMediaQuery("(min-width:768px) and (max-width:1024px)"); // استهداف iPad إن احتجت
  const [orders, setOrders] = useState([]);
  const [filterStatus, setFilterStatus] = useState("الكل");
  const [searchQuery, setSearchQuery] = useState("");
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [isAddItemsOpen, setIsAddItemsOpen] = useState(false);
  const [editOrderId, setEditOrderId] = useState(null);
  const [editStatusOpen, setEditStatusOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [pilotFilter, setPilotFilter] = useState("");
  const { hasPermission } = usePermissions();

  // NEW: حالة Dialog عرض أصناف الأوردر
  const [orderItemsDialogOpen, setOrderItemsDialogOpen] = useState(false);
  const [selectedOrderIdForItems, setSelectedOrderIdForItems] = useState(null);

  // هل يمكن للمستخدم رؤية طلبات الحالة "طلب خارجي"؟
  const canViewExternalOrders = hasPermission("orders_delivery_api_orders");
  // الحالات المتاحة للتغيير
  const statusOptions = [
    { value: "out_of_preparation", label: "مكتمل" },
    { value: "pending", label: "تجهيز" },
  ];

  // تغيير حالة الأوردر
  const handleChangeOrderStatus = async () => {
    if (!editOrderId || !selectedStatus) return;
    try {
      await changeOrderStatus(editOrderId, selectedStatus);
      setEditStatusOpen(false);
      setEditOrderId(null);
      setSelectedStatus("");
      loadOrders();
    } catch (err) {
      alert("فشل تغيير حالة الأوردر");
    }
  };

  const loadOrders = async () => {
    try {
      const branchId = localStorage.getItem("branch_id");
      if (!branchId) throw new Error("❌ لا يوجد branch_id في localStorage");

      const data = await fetchDeliveryOrders(branchId);
      const enriched = data.map((item) => ({
        id: item.id,
        status:
          item.status === "pending"
            ? "في التجهيز"
            : item.status === "completed"
            ? "مكتمل"
            : item.status === "out_of_preparation"
            ? "مكتمل"
            : item.status === "underway"
            ? "قيد التوصيل"
            : item.status === "delivered"
            ? "تم التسليم"
            : item.status === "under_review"
            ? "طلب خارجي"
            : item.status,
        customer: item.customer?.name || "-",
        pilotName: item.delivery?.name || "-",
        phone: item.customer?.phone1 || "",
        address: item.customer?.address1 || "",
        time: item.open_time || "-",
        total: item.total || 0,
        orderNumber: `#0${item.general_increment}`,
        timer: 0,
        // NEW: عدد الأصناف في الطلب
        itemsCount: Array.isArray(item.items) ? item.items.length : 0,
      }));

      // إذا المستخدم لا يملك صلاحية الاطلاع على طلبات "طلب خارجي" نزيلها من القائمة
      const finalList = canViewExternalOrders
        ? enriched
        : enriched.filter((o) => o.status !== "طلب خارجي");

      setOrders(finalList);
    } catch (err) {
      console.error("❌ فشل تحميل طلبات الدليفري:", err.message);
    }
  };

  // إعادة تحميل عند تغيير صلاحية العرض أيضاً
  useEffect(() => {
    loadOrders();
  }, [canViewExternalOrders]);

  // تم إلغاء عداد الوقت
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setOrders((prevOrders) =>
  //       prevOrders.map((order) =>
  //         ["في التجهيز", "قيد التوصيل"].includes(order.status)
  //           ? { ...order, timer: order.timer + 1 }
  //           : order
  //       )
  //     );
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, []);
  useEffect(() => {
    localStorage.setItem("current_component", "delivery");
  }, []);

  // ✅ useEffect لإضافة اختصار F6 لإنشاء طلب جديد
  useEffect(() => {
    const handleKeyDown = (e) => {
      // التحقق من F6 (keyCode 117)
      if (e.key === 'F6' || e.keyCode === 117) {
        e.preventDefault(); // منع السلوك الافتراضي
        if (hasPermission("orders_other_edite_service")) {
          setIsCreateOpen(true);
        }
      }
    };

    // إضافة المستمع
    window.addEventListener('keydown', handleKeyDown);

    // تنظيف المستمع عند unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [hasPermission]);

  // تحديث البيانات كل 10 دقائق
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     loadOrders();
  //   }, 10 * 60 * 1000); // 10 دقائق بالمللي ثانية
  //   return () => clearInterval(interval);
  // }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  const formatTime12 = (timeStr) => {
    if (!timeStr) return "-";
    const [h, m] = timeStr.split(":");
    let hour = Number(h);
    const ampm = hour >= 12 ? "م" : "ص";
    hour = hour % 12 || 12;
    return `${hour}:${m} ${ampm}`;
  };

  // حساب عدد الطلبات لكل حالة
  const tabStatuses = [
    { key: "الكل", label: "الكل" },
    { key: "مكتمل", label: "مكتمل" },
    { key: "في التجهيز", label: "في التجهيز" },
    { key: "قيد التوصيل", label: "قيد التوصيل" },
    { key: "تم التسليم", label: "تم التسليم" },
    { key: "طلب خارجي", label: "طلب خارجي" }, // 👈 تابة جديدة
  ];

  // لو المستخدم لا يملك الصلاحية نخفي تاب "طلب خارجي"
  const visibleTabStatuses = tabStatuses.filter(
    (t) => !(t.key === "طلب خارجي" && !canViewExternalOrders)
  );

  const getTabCount = (status) => {
    if (status === "الكل") {
      // عدد الطلبات المعروضة فعلياً في تاب الكل
      return orders.filter((order) => {
        let statusAr = order.status;
        if (order.status === "underway") statusAr = "قيد التوصيل";
        if (order.status === "delivered") statusAr = "تم التسليم";
        if (order.status === "under_review") statusAr = "طلب خارجي";
        // استبعاد "طلب خارجي" و "finished"
        return !(statusAr === "طلب خارجي" || order.status === "finished");
      }).length;
    }
    return orders.filter((order) => {
      let statusAr = order.status;
      if (order.status === "underway") statusAr = "قيد التوصيل";
      if (order.status === "delivered") statusAr = "تم التسليم";
      if (order.status === "under_review") statusAr = "طلب خارجي";
      return statusAr === status;
    }).length;
  };

  const filteredOrders = orders.filter((order) => {
    // تحويل حالة النظام إلى العربية للفلترة
    let statusAr = order.status;
    if (order.status === "underway") statusAr = "قيد التوصيل";
    if (order.status === "delivered") statusAr = "تم التسليم";
    if (order.status === "under_review") statusAr = "طلب خارجي";

    // في تاب "الكل" لا تعرض "طلب خارجي" ولا "finished"
    if (
      filterStatus === "الكل" &&
      (statusAr === "طلب خارجي" || order.status === "finished")
    )
      return false;

    const searchFields = [
      order.customer,
      order.pilotName,
      order.phone,
      order.address,
      order.time,
      order.total.toString(),
      order.orderNumber,
    ]
      .join(" ")
      .toLowerCase();

    return (
      (filterStatus === "الكل" || statusAr === filterStatus) &&
      searchFields.includes(searchQuery.toLowerCase()) &&
      (pilotFilter === "" || order.pilotName === pilotFilter)
    );
  });

  const statusColors = {
    مكتمل: "#4CAF50",
    "في التجهيز": "#FFC107",
    "قيد التوصيل": "#2196F3",
  };

  // NEW: دالة فتح Dialog عرض الأصناف
  const handleOpenOrderItems = (orderId) => {
    setSelectedOrderIdForItems(orderId);
    setOrderItemsDialogOpen(true);
  };
  
  // NEW: دالة إغلاق Dialog عرض الأصناف
  const handleCloseOrderItems = () => {
    setOrderItemsDialogOpen(false);
    setSelectedOrderIdForItems(null);
  };

  return (
    <Box sx={{ p: 2, bgcolor: mode === "dark" ? "#1F1D2B" : "#fff" }}>
      {/* فلاتر البحث */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // متجاوب: أعمدة على موبايل، صف على تابلت+
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {visibleTabStatuses.map((tab) => (
            <Button
              key={tab.key}
              variant={filterStatus === tab.key ? "contained" : "outlined"}
              onClick={() => setFilterStatus(tab.key)}
              size="small"
            >
              {tab.label}
              <Box
                component="span"
                sx={{
                  ml: 1,
                  px: 1.2,
                  py: 0.2,
                  bgcolor: "#fff",
                  color: "#232334",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  fontSize: "13px",
                  minWidth: "28px",
                  display: "inline-block",
                }}
              >
                {getTabCount(tab.key)}
              </Box>
            </Button>
          ))}
        </Box>
        <Box sx={{ display: "flex", gap: 2, mt: { xs: 1, sm: 0 }, alignItems: "center" }}>
          <TextField
            placeholder="البحث عن الطلبات..."
            size={isTablet ? "medium" : "small"} // متجاوب
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            variant="outlined"
            sx={{ width: { xs: 160, sm: 220, md: 300 }, minWidth: 140 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton onClick={() => setSearchQuery("")}>
                    {" "}
                    <ClearIcon />{" "}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {/* فلتر الدليفري */}
          <TextField
            select
            label="الدليفري"
            size={isTablet ? "medium" : "small"}
            value={pilotFilter || ""}
            onChange={(e) => setPilotFilter(e.target.value)}
            sx={{ minWidth: { xs: 110, sm: 140, md: 180 } }}
          >
            <MenuItem value="">الكل</MenuItem>
            {[...new Set(orders.map((o) => o.pilotName).filter(Boolean))].map(
              (name, idx) => (
                <MenuItem key={idx} value={name}>
                  {name}
                </MenuItem>
              )
            )}
          </TextField>

          {hasPermission("orders_other_edite_service") && (
            <Button
              variant="contained"
              onClick={() => setIsCreateOpen(true)}
              size={isTablet ? "medium" : "small"}
              title="إنشاء طلب جديد (F6)"
            >
              إنشاء طلب جديد
            </Button>
          )}
        </Box>
      </Box>
      {/* قائمة الطلبات */}
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        {filteredOrders.map((order, idx) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={isTablet ? 6 : 4} // على التابلت عمودين، على شاشات أكبر ثلاثة أو أربعة
            lg={3}
            key={order.id}
          >
            <Paper
              sx={{
                background: "linear-gradient(135deg, #232334 60%, #232334 100%)",
                color: "#fff",
                borderRadius: 3,
                boxShadow: "0 4px 24px #0004",
                p: { xs: 0.5, sm: 1, md: 1.2 },
                overflow: "hidden",
                minHeight: { xs: 150, sm: 170, md: 200 },
                position: "relative",
                cursor: "pointer",
                transition: "box-shadow 0.18s, transform 0.18s",
                "&:hover": {
                  boxShadow: "0 8px 32px #EA7C6988",
                  transform: { md: "scale(1.03)" },
                },
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
              onClick={() => {
                setSelectedOrderId(order.id);
                setIsAddItemsOpen(true);
              }}
            >
              {/* Header: Order Number & Status */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1.2,
                  pb: 0.5,
                  gap: 2,
                  position: "relative",
                }}
              >
                {/* NEW: أيقونة عدد الأصناف - في البداية */}
                {order.itemsCount > 0 && (
                  <Box
                    sx={{
                      zIndex: 10,
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenOrderItems(order.id);
                    }}
                  >
                    <Badge
                      badgeContent={order.itemsCount}
                      color="error"
                      max={99}
                      sx={{
                        "& .MuiBadge-badge": {
                          fontSize: { xs: "8px", sm: "9px" },
                          fontWeight: 700,
                          minWidth: { xs: "14px", sm: "16px" },
                          height: { xs: "14px", sm: "16px" },
                          padding: "0 3px",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          bgcolor: mode === "dark" ? "#1a1a2e" : "#fff",
                          borderRadius: "50%",
                          width: { xs: 28, sm: 32 },
                          height: { xs: 28, sm: 32 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
                          border: `2px solid ${mode === "dark" ? "#444" : "#e0e0e0"}`,
                          transition: "all 0.2s",
                          "&:hover": {
                            transform: "scale(1.1)",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
                          },
                          "&:active": {
                            transform: "scale(0.95)",
                          },
                        }}
                      >
                        <RestaurantMenuIcon
                          sx={{
                            fontSize: { xs: 14, sm: 16 },
                            color: mode === "dark" ? "#fff" : "#666",
                          }}
                        />
                      </Box>
                    </Badge>
                  </Box>
                )}

                {/* المحتوى الموجود - الحالة ورقم الطلب */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1, justifyContent: "flex-end" }}>
                  {/* الحالة بشكل شارة دائرية مع نص */}
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: 1, ml: 2 }}
                  >
                    <Typography sx={{ fontWeight: 600, fontSize: { xs: 14, sm: 16, md: 18 } }}>
                      {order.status}
                    </Typography>
                    {/* زر تعديل الحالة */}

                    {hasPermission("orders_other_edite_service") && (
                      <IconButton
                        size={isTablet ? "medium" : "small"}
                        sx={{ ml: 0.5, color: "#FFC107" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditOrderId(order.id);
                          setEditStatusOpen(true);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    )}
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        bgcolor:
                          order.status === "مكتمل"
                            ? "#4CAF50"
                            : order.status === "في التجهيز"
                            ? "#FFC107"
                            : order.status === "قيد التوصيل"
                            ? "#2196F3"
                            : "#fff",
                      }}
                    />
                  </Box>
                  {/* رقم الطلب */}
                  <Box
                    sx={{
                      bgcolor: "#1ecb6b",
                      color: "#fff",
                      px: 2,
                      py: 0.5,
                      borderRadius: "10px",
                      fontWeight: 700,
                      fontSize: { xs: 14, sm: 16, md: 18 },
                      boxShadow: "0 2px 8px #0002",
                      display: "flex",
                      alignItems: "center",
                      minWidth: 60,
                      justifyContent: "center",
                    }}
                  >
                    {order.orderNumber}
                  </Box>
                </Box>
              </Box>

              {/* Time */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  pt: 0.5,
                }}
              >
                <Typography variant="caption" sx={{ color: "#b0bec5" }}>
                  {formatTime12(order.time)}
                </Typography>
                {/* تم إلغاء التايمر */}
              </Box>

              {/* Main Content */}
              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                  alignItems: "flex-end",
                }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: { xs: 15, sm: 18 }, color: "#fff" }}>
                  {order.customer}
                </Typography>
                <Typography sx={{ fontSize: { xs: 13, sm: 15 }, color: "#fff" }}>
                  {order.phone}
                </Typography>
                <Typography sx={{ fontSize: { xs: 12, sm: 15 }, color: "#b0bec5" }}>
                  {order.address}
                </Typography>
                {/* عرض اسم الدليفري */}
                <Typography sx={{ fontSize: { xs: 13, sm: 15 }, color: "#90caf9", fontWeight: 500 }}>
                  الدليفري: {order.pilotName}
                </Typography>
              </Box>

              {/* Footer: Total */}
              <Box
                sx={{
                  bgcolor: "#F8BBD0",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: { xs: 16, sm: 18, md: 20 },
                  px: { xs: 2, sm: 2.5 },
                  py: { xs: 0.6, sm: 0.7 },
                  borderRadius: "16px",
                  position: "absolute",
                  bottom: 12,
                  right: 12,
                  boxShadow: "0 2px 8px #0002",
                  minWidth: 70,
                  textAlign: "center",
                  letterSpacing: 1.2,
                  border: "2px solid #fff2",
                }}
              >
                ${order.total}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      {/* مودال إنشاء الطلب */}
      {isCreateOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.25)",
            zIndex: 1400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              borderRadius: 3,
              boxShadow: 8,
              p: { xs: 1, sm: 2, md: 3 },
              width: "min(95vw, 900px)",
              maxHeight: "94vh",
              overflowY: "auto",
              position: "relative",
            }}
          >
            <CreateOrderForm
              onSuccess={(res) => {
                const createdId = res?.id;
                if (!createdId) return alert("❌ فشل في جلب رقم الطلب الجديد");

                setSelectedOrderId(createdId);
                setIsCreateOpen(false);
                setIsAddItemsOpen(true);
                loadOrders();
              }}
            />
            <IconButton
              onClick={() => setIsCreateOpen(false)}
              sx={{
                position: "absolute",
                top: 8,
                left: 8,
                color: "#EA7C69",
                zIndex: 10,
              }}
            >
              <ClearIcon />
            </IconButton>
          </Box>
        </Box>
      )}
      {/* Dialog TableModalDialog */}
      <DeliveryModalContent
        open={isAddItemsOpen}
        onClose={() => setIsAddItemsOpen(false)}
        type="addItem"
        orderId={selectedOrderId}
        tableId={null}
        rootId={localStorage.getItem("branch_id")}
        onSuccess={() => {
          setIsAddItemsOpen(false);
          loadOrders();
        }}
      />
      {/* مودال تغيير الحالة */}
      {editStatusOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.25)",
            zIndex: 1500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              borderRadius: 3,
              boxShadow: 8,
              p: { xs: 2, sm: 3 },
              width: "min(92vw, 380px)",
              textAlign: "center",
              position: "relative",
              color: mode === "dark" ? "#fff" : "#232334",
            }}
          >
            <Typography
              variant="h6"
              sx={{ mb: 2, color: mode === "dark" ? "#fff" : "#232334" }}
            >
              تغيير حالة الطلب
            </Typography>
            {/* عرض اسم العميل ورقم الهاتف بجوار تغيير الحالة */}
            {(() => {
              const order = orders.find((o) => o.id === editOrderId);
              if (!order) return null;
              return (
                <Box
                  sx={{
                    mb: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: mode === "dark" ? "#fff" : "#232334",
                    }}
                  >
                    العميل: {order.customer}
                  </Typography>
                  <Typography
                    sx={{ color: mode === "dark" ? "#fff" : "#232334" }}
                  >
                    الهاتف: {order.phone}
                  </Typography>
                </Box>
              );
            })()}
            <TextField
              select
              label="اختر الحالة الجديدة"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              fullWidth
              sx={{
                mb: 2,
                bgcolor: mode === "dark" ? "#232334" : "#fff",
                color: mode === "dark" ? "#fff" : "#232334",
                "& .MuiInputBase-input": {
                  color: mode === "dark" ? "#fff" : "#232334",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: mode === "dark" ? "#888" : "#ccc",
                },
              }}
              SelectProps={{
                MenuProps: {
                  disablePortal: true,
                  PaperProps: {
                    sx: {
                      zIndex: 2000,
                      bgcolor: mode === "dark" ? "#232334" : "#fff",
                      color: mode === "dark" ? "#fff" : "#232334",
                      "& .MuiMenuItem-root": {
                        "&:hover": {
                          bgcolor:
                            mode === "dark" ? "#333" : "rgba(0,0,0,0.04)",
                        },
                      },
                    },
                  },
                },
              }}
            >
              {statusOptions.map((opt) => (
                <MenuItem
                  key={opt.value}
                  value={opt.value}
                  sx={{
                    bgcolor: mode === "dark" ? "#232334" : "#fff",
                    color: mode === "dark" ? "#fff" : "#232334",
                  }}
                >
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
            <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleChangeOrderStatus}
                disabled={!selectedStatus}
              >
                حفظ
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setEditStatusOpen(false);
                  setEditOrderId(null);
                  setSelectedStatus("");
                }}
              >
                إلغاء
              </Button>
            </Box>
          </Box>
        </Box>
      )}
      {/* NEW: Dialog عرض أصناف الأوردر */}
      <OrderItemsDialog
        open={orderItemsDialogOpen}
        onClose={handleCloseOrderItems}
        orderId={selectedOrderIdForItems}
      />
    </Box>
  );
};

export default TabletDeliverySection;
